import { Component, OnInit } from '@angular/core';
import { CustomerService } from '../../shared/';
import { ActivatedRoute, Router } from '@angular/router';
import { Customer } from '../../models/customer';
import { MatDialog } from '@angular/material/dialog';
import {
  MatRadioButton,
  MatRadioChange,
  MatRadioGroup
} from '@angular/material/radio';
import { ConfirmDialogComponent } from '../../shared';
import { FormsModule } from '@angular/forms';
import { MatCard, MatCardContent } from '@angular/material/card';
import { MatFormField } from '@angular/material/form-field';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { NgIf } from '@angular/common';
import { MatInput } from '@angular/material/input';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatButton } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout';

@Component({
  selector: 'edit-customer',
  templateUrl: './edit.customer.component.html',
  styleUrls: ['./edit.customer.component.css'],
  providers: [CustomerService],
  standalone: true,
  imports: [
    MatRadioGroup,
    FormsModule,
    MatRadioButton,
    MatCard,
    MatCardContent,
    MatFormField,
    MatSlideToggle,
    MatInput,
    MatCheckbox,
    MatButton,
    FlexModule,
    NgIf
  ]
})
export class EditCustomerComponent implements OnInit {
  customer;
  customerName = '';
  model: Customer;

  constructor(
    private route: ActivatedRoute,
    private customerService: CustomerService,
    private router: Router,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.route.params.subscribe((params) => {
      let id = parseInt(params['customerId'], 10);
      this.customerService.getCustomer(id).subscribe(
        (response) => {
          this.model = response;
          if (!this.model.extras) {
            this.model.extras = { require_po: false };
          }
          this.customer = JSON.parse(JSON.stringify(response)) as Customer;
          this.customerName = this.customer.name;
        },
        (error) => {}
      );
    });
  }

  public submit() {
    this.customerService
      .updateCustomer(this.model)
      .subscribe(() => this.backToCustomer());
  }

  public backToCustomer() {
    this.router.navigate(['/customer/' + this.customer.id]);
  }

  typeChanged(event: MatRadioChange) {
    if (event.value === 1) {
      this.customerService.changedToBusiness(this.model);
      return;
    }
    if (event.value === 1) {
      this.customerService.changeToIndividual(this.model);
      return;
    }
  }

  deleteCustomer() {
    let confirmDialog = this.dialog.open(ConfirmDialogComponent, {});
    confirmDialog.componentInstance.message = `Are you sure you want to delete ${this.customerService.getName(
      this.customer
    )}?
        Warning: This cannot be undone!`;
    confirmDialog.componentInstance.title = 'Delete Customer';
    confirmDialog.componentInstance.type = 'delete';

    confirmDialog.afterClosed().subscribe((value) => {
      if (value) {
        this.customerService.delete(this.customer.id).subscribe(() => {
          this.customer.deleted = 1;
          this.backToCustomer();
        });
      }
    });
  }
}
